export default {
    MODAL_TYPE: {
        BASE: 'base',
        ON_CLOSE: 'onclose',
        FEEDBACK: 'feedback',
        SELECT: {
            ADC: 'adcSelect',
            DRIVER: 'driverSelect',
        },
    },

    MODAL_CONFIG: {
        ABOUT: 'about',
        BROWSER_ISSUE: 'browserIssue',
        VIDEOS: 'videos',
        FEEDBACK: 'feedback',
        SELECT: {
            ADC: 'adcSelect',
            DRIVER: 'driverSelect',
        },
    },

    CLASSES: {
        HIDDEN: 'hidden',
    },

    /**
     * Currently Escape and Left are not being used but I am putting them in for future reference
     * Any handling of Escape or Left will need to check for both given keys
     */
    KEYS: {
        ENTER: ['Enter'],
        ESCAPE: ['Escape', 'Esc'],
        LEFT: ['Left', 'ArrowLeft'],
    },

    API_TOOL_ID: 6,

    QA_ATTR_NAME: 'data-qa-element',
    QA_ATTR_PREFIX: 'adc_driver',

    DRIVER_TYPE: {
        AMP: 'Amp',
        DIFF_AMP: 'DiffAmp',
    },

    ADC_TYPE: {
        DIFF: 'DIFF',
        SE: 'SE',
    },

    SOURCE_TYPE: {
        SE: 1,
        DIFF: 2,
    },

    KICKBACK_TYPE: {
        FIXED: 'fixed',
        PREV_SAMPLE: 'prevSample',
    },

    VARIANT: {
        ADC: {
            HIZ: 'HiZ',
            PRECHARGE_ON: 'PrechargeOn',
            SEQ: 'Seq',
        },
        DRIVER: {
            LP: 'LP',
            FP: 'FP',
        },
    },

    TOPOLOGY: {
        INVERTING: 1,
        NON_INVERTING: 2,
        FOLLOWER: 3,
    },

    TAB_TYPE: {
        MAIN: 'main',
        NOISE: 'noise',
        SETTLING: 'settling',
    },

    TAB_INDEX: {
        MAIN: {
            CIRCUIT: 1,
            NOISE_DISTORTION: 2,
            INPUT_SETTLING: 3,
            NEXT_STEPS: 4,
            DRIVER_PERFORMANCE: 5,
        },
        NOISE: {
            THD: 1,
            NOISE: 2,
        },
        SETTLING: {
            DC: 1,
            AC: 2,
            MUXED: 3,
        },
    },

    INPUT_SETTLING_TAB: {
        1: 'lsb',
        2: 'volts',
        3: 'ppm',
    },

    NOISE_TAB_NAME: {
        THD: 1,
        SINAD: 2,
        ENOB: 3,
    },

    ARCHITECTURE: {
        SAR: 'SAR',
        SIGMA_DELTA: 'sigma-delta',
    },

    CONFIGURATION: {
        SEADC: 'SEADC',
        DiffADC_SEAmp_SESource: 'DiffADC-SEAmp-SESource',
        DiffADC_DiffAmp_SESource: 'DiffADC-DiffAmp-SESource',
        DiffADC_DiffAmp_DiffSource: 'DiffADC-DiffAmp-DiffSource',
        DiffADC_SEAmp_DiffSource: 'DiffADC-SEAmp-DiffSource',
    },

    SVG: {
        SEADC_SESource_SEAmp_Inverting: 'SEADC-SESource-SEAmp-Inverting',
        SEADC_SESource_SEAmp_NonInverting: 'SEADC-SESource-SEAmp-NonInverting',
        SEADC_SESource_SEAmp_Follower: 'SEADC-SESource-SEAmp-Follower',
        SEADC_SESource_SEAmp_Inverting_InternalMux: 'SEADC-SESource-SEAmp-Inverting-InternalMux',
        SEADC_SESource_SEAmp_NonInverting_InternalMux: 'SEADC-SESource-SEAmp-NonInverting-InternalMux',
        SEADC_SESource_SEAmp_Follower_InternalMux: 'SEADC-SESource-SEAmp-Follower-InternalMux',
        DiffADC_SESource_SEAmp_Inverting: 'DiffADC-SESource-SEAmp-Inverting',
        DiffADC_SESource_SEAmp_NonInverting: 'DiffADC-SESource-SEAmp-NonInverting',
        DiffADC_SESource_DiffAmp_Inverting: 'DiffADC-SESource-DiffAmp-Inverting',
        DiffADC_DiffSource_SEAmp_Inverting: 'DiffADC-DiffSource-SEAmp-Inverting',
        DiffADC_DiffSource_SEAmp_NonInverting: 'DiffADC-DiffSource-SEAmp-NonInverting',
        DiffADC_DiffSource_DiffAmp_Inverting: 'DiffADC-DiffSource-DiffAmp-Inverting',
        DiffADC_DiffSource_SEAmp_Follower: 'DiffADC-DiffSource-SEAmp-Follower',
        DiffADC_SESource_SEAmp_Follower: 'DiffADC-SESource-SEAmp-Follower',
        DiffADC_DiffSource_DiffAmp_Inverting_AD408x: 'DiffADC-DiffSource-DiffAmp-Inverting-AD408x',
        DiffADC_DiffSource_DiffAmp_Inverting_InputMux_AD408x: 'DiffADC-DiffSource-DiffAmp-Inverting-InputMux-AD408x',
        DiffADC_DiffSource_DiffAmpFixedGain_Inverting_AD408x: 'DiffADC-DiffSource-DiffAmpFixedGain-Inverting-AD408x',
        DiffADC_DiffSource_DiffAmpFixedGain_Inverting_InputMux_AD408x:
            'DiffADC-DiffSource-DiffAmpFixedGain-Inverting-InputMux-AD408x',
        DiffADC_DiffSource_SEAmp_Follower_AD408x: 'DiffADC-DiffSource-SEAmp-Follower-AD408x',
        DiffADC_DiffSource_SEAmp_Follower_InputMux_AD408x: 'DiffADC-DiffSource-SEAmp-Follower-InputMux-AD408x',
        DiffADC_DiffSource_SEAmp_Inverting_AD408x: 'DiffADC-DiffSource-SEAmp-Inverting-AD408x',
        DiffADC_DiffSource_SEAmp_Inverting_InputMux_AD408x: 'DiffADC-DiffSource-SEAmp-Inverting-InputMux-AD408x',
        DiffADC_DiffSource_SEAmp_NonInverting_AD408x: 'DiffADC-DiffSource-SEAmp-NonInverting-AD408x',
        DiffADC_DiffSource_SEAmp_NonInverting_InputMux_AD408x: 'DiffADC-DiffSource-SEAmp-NonInverting-InputMux-AD408x',
        DiffADC_SESource_SEAmp_Inverting_InputMux_AD408x: 'DiffADC-SESource-SEAmp-Inverting-InputMux-AD408x',
        DiffADC_SESource_SEAmp_NonInverting_InputMux_AD408x: 'DiffADC-SESource-SEAmp-NonInverting-InputMux-AD408x',
        DiffADC_SESource_SEAmp_Follower_InputMux_AD408x: 'DiffADC-SESource-SEAmp-Follower-InputMux-AD408x',

        PARTS: {
            InternalMux: 'InternalMux',
            InputMux: 'InputMux',
            DiffAmpFixedGain: 'DiffAmpFixedGain',
            DiffAmp: 'DiffAmp',
        },
    },

    URL: {
        AD_CONVERTERS: '2418',
        OPAMPS: '2402',
        DIFFAMPS: '2397',
        PRECISION_ADCS: '2418',
        SAR_ADCS: '2418#/p897=SAR',
    },
};
